/* eslint-disable jsx-a11y/anchor-is-valid */
import PerfectScrollbar from "perfect-scrollbar";
import React, { useRef } from "react";
import { NavLink } from 'react-router-dom';
import { Collapse, Nav } from "reactstrap";
import { useRecoilValue } from "recoil";
import { BBBEEScorecardAtom } from "../../../State/BBBEEScorecard.Atom";
import { ConsolidationAtom } from "../../../State/Consolidation.Atom";
import { OrganisationAtom } from "../../../State/Organisation.Atom";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { VerificationCompanyAtom } from "../../../State/VerificationCompany.Atom";
import { WSPScorecardAtom } from "../../../State/WSPScorecard.Atom";
import { UserAtom, userRolesState } from "../../../State/user.Atom";
import { AccountRoutes, ProtectedRoute } from "../Constants/routes";
import { ClientRegistrationAtom } from "../../../State/Advisory/ClientRegistration.Atom";

interface IProps {
    className?: string;
    color?: "primary" | "info" | "success" | "warning" | "danger" | "transparent" | "white" | "rose" | "dark";
    links?: React.ReactNode;
    logo?: string;
    image?: string;
    fixed?: boolean;
    absolute?: boolean;
    ProtectedRoutes: ProtectedRoute[];
    ConstantRoutes: ProtectedRoute[];
    LoggedInUser: string;
    AccountRoutes: AccountRoutes[];
    AdvisoryRoutes: ProtectedRoute[] | null;
    [key: string]: any;
}
var ps: any;
export function Sidebar(props: IProps) {
    const scorecard = useRecoilValue(ScorecardAtom);
    const WSPScorecard = useRecoilValue(WSPScorecardAtom);
    const BBBEEScorecard = useRecoilValue(BBBEEScorecardAtom);
    const peoplAndTraining = useRecoilValue(OrganisationAtom);
    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const [openAvatar, setOpenAvatar] = React.useState<boolean>(false);
    const [collapseStates, setCollapseStates] = React.useState<any>({});
    const userRoles = useRecoilValue(userRolesState);
    const currentUser = useRecoilValue(UserAtom);
    const isConsolidationScorecard = useRecoilValue(ConsolidationAtom);
    const clientRegistration = useRecoilValue(ClientRegistrationAtom)
    const { isSidebarCollapsed } = props;
    const [hasScrolled, setHasScrolled] = React.useState(false);
    const [hasScrolledBEE, setHasScrolledBEE] = React.useState(false);
    const eeScorecardSideBarRef = useRef<HTMLDivElement | null>(null);
    const beeScorecardSideBarRef = useRef<HTMLDivElement | null>(null);

    const getCollapseStates = (routes: any) => {
        let initialState = {};
        routes.map((prop: any, key: number) => {
            if (prop.collapse) {
                initialState = {
                    [prop.state]: getCollapseInitialState(prop.views),
                    ...getCollapseStates(prop.views),
                    ...initialState,
                };
            }
            return null;
        });
        return initialState;
    };

    const getCollapseInitialState = (routes: any) => {
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
                return true;
            } else if (window.location.pathname.indexOf(routes[i].path) !== -1) {
                return true;
            }
        }
        return false;
    };

    const createAccountRoutes = (routes: AccountRoutes[]) => {
        return routes.map((prop: AccountRoutes, key: number) => {
            if (prop.userRoleIncludes != null) {
                if (!userRoles.some(r => prop.userRoleIncludes?.includes(r))) {
                    return null;
                }
            }
            if (prop.userRoleExcludes != null) {
                if (userRoles.some(r => prop.userRoleExcludes?.includes(r))) {
                    return null;
                }
            }
            return (
                <li className={activeRoute(prop.layout + prop.path)} key={key}>
                    <NavLink to={prop.layout + prop.path} className={(navData) => (navData ? "" : 'none')}>
                        <span className={prop.iconClass}>{prop.MenuAbv}</span>
                        <span className={prop.className}>{prop.MenuItemName}</span>
                    </NavLink>
                </li>
            )
        })
    }

    const toggleCollapse = (propState: string) => {
        setCollapseStates((prevState: any) => ({
            ...prevState,
            [propState]: !prevState[propState],
        }));
    };

    const createLinks = (routes: any[], depth: number = 0) => {
        return routes.map((prop: any, key: number) => {
            if (prop.isConsolidatedRoute && !isConsolidationScorecard) {
                return null;
            }
            if(prop.isAPIExternal && prop.isAPIExternal != null){
                if(!currentUser.isAPIRegistration){
                    return null;
                }
            }
            if (!prop.visible && prop.visible != null) {
                return null;
            }

            if (prop.userRoleIncludes != null) {
                if (!userRoles.some(r => prop.userRoleIncludes?.includes(r))) {
                    return null;
                }
            }

            if (prop.userRoleExcludes != null) {
                if (userRoles.some(r => prop.userRoleExcludes?.includes(r))) {
                    return null;
                }
            }

            if (prop.redirect) {
                return null;
            }

            if (prop.collapse) {
                return (
                    <li
                        className={getCollapseInitialState(prop.views) ? "active" : ""}
                        key={key}
                    >
                        <a
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={collapseStates[prop.state]}
                            onClick={(e) => {
                                e.preventDefault();
                                toggleCollapse(prop.state);
                            }}
                        >
                            {prop.icon !== undefined ? (
                                <>
                                    <i className={prop.icon} />
                                    <p>
                                        {prop.name}
                                        <b className="caret" />
                                    </p>
                                </>
                            ) : (
                                <>
                                    <span className="sidebar-mini-icon">{prop.mini}</span>
                                    <span className="sidebar-normal">
                                        {prop.name}
                                        <b className="caret" />
                                    </span>
                                </>
                            )}
                        </a>
                        <Collapse isOpen={collapseStates[prop.state]}>
                            <ul className='nav'>
                                {createLinks(prop.views, depth + 1)}
                            </ul>
                        </Collapse>
                    </li>
                );
            }

            if (prop.hasChildren === true && prop.collapse === false) {
                return (
                    <li className={activeRoute((prop.layout + prop.path).replaceAll(':scorecardId', scorecard?.scorecardId ?? '')
                        .replaceAll(":BBBEEScorecardId", BBBEEScorecard.scorecardId ?? "")
                        .replaceAll(":WSPScorecardId", WSPScorecard.wspScorecardId ?? "")
                        .replaceAll(":WSPScorecardName", WSPScorecard.wspScorecardName ?? "")
                        .replaceAll(":organisationId", WSPScorecard.organisationId ?? "")
                        .replaceAll(":OrganisationId", peoplAndTraining.OrganisationId ?? "")
                        .replaceAll(":SetaTypeId", peoplAndTraining.SetaTypeId ?? "0")
                        .replaceAll(":OrganisationName", peoplAndTraining.OrganisationName ?? "")
                        .replaceAll(":registrationId", clientRegistration.clientRegistrationId ?? "")
                        .replaceAll(":registrationName", clientRegistration.clientRegistrationName ?? ""))} key={key}>
                        <NavLink to={
                            (prop.layout + prop.path).replaceAll(':scorecardId', scorecard?.scorecardId ?? '')
                                .replaceAll(":BBBEEScorecardId", BBBEEScorecard.scorecardId ?? "")
                                .replaceAll(":WSPScorecardId", WSPScorecard.wspScorecardId ?? "")
                                .replaceAll(":WSPScorecardName", WSPScorecard.wspScorecardName ?? "")
                                .replaceAll(":organisationId", WSPScorecard.organisationId ?? "")
                                .replaceAll(":OrganisationId", peoplAndTraining.OrganisationId ?? "")
                                .replaceAll(":SetaTypeId", peoplAndTraining.SetaTypeId ?? "0")
                                .replaceAll(":OrganisationName", peoplAndTraining.OrganisationName ?? "")
                                .replaceAll(":registrationId", clientRegistration.clientRegistrationId ?? "")
                                .replaceAll(":registrationName", clientRegistration.clientRegistrationName ?? "")} 
                                className={(navData) => (navData ? "" : 'none')} style={{ marginBottom: '0px' }}>
                            {prop.icon !== undefined ?
                                <>
                                    <i className={prop.icon} />
                                    <p>{prop.name}</p>
                                </>
                                :
                                <>
                                    <span className="sidebar-mini-icon">{prop.mini}</span>
                                    <span className="sidebar-normal">{prop.name}</span>
                                </>
                            }
                        </NavLink>
                        <ul className='custom-nav'>
                            {createLinks(prop.views, depth + 1)}
                        </ul>
                    </li>
                );
            }

            return (
                <li className={activeRoute((prop.layout + prop.path).replaceAll(':scorecardId', scorecard?.scorecardId ?? '')
                    .replaceAll(":BBBEEScorecardId", BBBEEScorecard.scorecardId ?? "")
                    .replaceAll(":WSPScorecardId", WSPScorecard.wspScorecardId ?? "")
                    .replaceAll(":WSPScorecardName", WSPScorecard.wspScorecardName ?? "")
                    .replaceAll(":organisationId", WSPScorecard.organisationId ?? "")
                    .replaceAll(":OrganisationId", peoplAndTraining.OrganisationId ?? "")
                    .replaceAll(":SetaTypeId", peoplAndTraining.SetaTypeId ?? "0")
                    .replaceAll(":OrganisationName", peoplAndTraining.OrganisationName ?? "")
                    .replaceAll(":registrationId", clientRegistration.clientRegistrationId ?? "")
                    .replaceAll(":registrationName", clientRegistration.clientRegistrationName ?? ""))} key={key}>
                    <NavLink to={(prop.layout + prop.path).replaceAll(':scorecardId', scorecard?.scorecardId ?? '')
                        .replaceAll(":BBBEEScorecardId", BBBEEScorecard.scorecardId ?? "")
                        .replaceAll(":WSPScorecardId", WSPScorecard.wspScorecardId ?? "")
                        .replaceAll(":WSPScorecardName", WSPScorecard.wspScorecardName ?? "")
                        .replaceAll(":organisationId", WSPScorecard.organisationId ?? "")
                        .replaceAll(":OrganisationId", peoplAndTraining.OrganisationId ?? "")
                        .replaceAll(":SetaTypeId", peoplAndTraining.SetaTypeId ?? "0")
                        .replaceAll(":OrganisationName", peoplAndTraining.OrganisationName ?? "")
                        .replaceAll(":registrationId", clientRegistration.clientRegistrationId ?? "")
                        .replaceAll(":registrationName", clientRegistration.clientRegistrationName ?? "")} 
                        className={(navData) => (navData ? "" : 'none')}>
                        {prop.subLevel !== true ? (
                            prop.icon !== undefined ? (
                                <>
                                    <i className={prop.icon} />
                                    <p>{prop.name}</p>
                                </>
                            ) : (
                                <>
                                    <span className="sidebar-mini-icon">{prop.mini}</span>
                                    <span className="sidebar-normal" style={{ whiteSpace: "normal", marginLeft: depth === 0 ? '45px' : (depth * 30 + 15) + 'px' }}>{prop.name}</span>
                                </>
                            )
                        ) : (
                            <>
                                <span className="sidebar-mini-icon" style={{ marginLeft: depth === 0 ? '15px' : (depth * 30 - 15) + 'px' }}>{`>`}</span>
                                <span className="sidebar-mini-icon">{prop.mini}</span>
                                <span className="sidebar-normal" style={{ whiteSpace: "normal", marginLeft: '45px' }}>{prop.name}</span>
                            </>
                        )
                        }
                    </NavLink>
                </li>
            );
        });
    };

    const activeRoute = (routeName: string) => {
        const decodedPath = decodeURIComponent(window.location.pathname);
        return decodedPath.indexOf(routeName) > -1 ? "active" : "";
    };

    const scrollToScorecardHeading = () => {
        if (eeScorecardSideBarRef.current) {
            eeScorecardSideBarRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setHasScrolled(true);
        }
    };

    const scrollToBEEScorecardHeading = () => {
        if (beeScorecardSideBarRef.current) {
            beeScorecardSideBarRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setHasScrolledBEE(true);
        }
    };

    React.useEffect(() => {

        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar('.sidebar', {
                suppressScrollX: true,
                suppressScrollY: false,
            });

            if (scorecard.scorecardId) {
                if (!hasScrolled) {
                    scrollToScorecardHeading();
                }
            } else {
                setHasScrolled(false);
            }

            if (BBBEEScorecard.scorecardId && !hasScrolledBEE && props.DynamicRoutes?.length > 0) {
                scrollToBEEScorecardHeading();
            }
        }

        return function cleanup() {
            if (navigator.platform.indexOf("Win") > -1) {
                ps.destroy();
            }
        };
    });

    React.useEffect(() => {
        setHasScrolledBEE(false);
    }, [BBBEEScorecard.scorecardId]); // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        setCollapseStates(getCollapseStates(props.ProtectedRoutes));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div
            className="sidebar"
            data-color={props.bgColor}
            data-active-color={props.activeColor}
        >
            {!currentUser.isClient && (
                <div className="logo">
                    <div className="logo-img" style={{ textAlign: "center" }}>
                        <img src={"https://app.bee123.co.za/Content/images/BEE_Logo_slogann.png"} alt="react-logo" style={{ maxWidth: "50%" }} />
                    </div>
                </div>
            )}
            <div className="sidebar-wrapper" style={{ overflowX: 'hidden' }}>
                {!currentUser.isClient &&
                    <div className='user'>
                        <div className="info">
                            <a
                                href="#"
                                data-toggle="collapse"
                                aria-expanded={openAvatar}
                                onClick={() => setOpenAvatar(!openAvatar)}
                            >
                                <span style={{ color: 'white' }}>
                                    {props.LoggedInUser}
                                    <b className="caret" />
                                </span>
                            </a>
                            <Collapse isOpen={openAvatar}>
                                <ul className="nav">
                                    {createAccountRoutes(props.AccountRoutes)}
                                </ul>
                            </Collapse>
                        </div>
                    </div>
                }
                {currentUser.isClient &&
                    <>
                        <div className="logo" style={{ paddingBottom: 0 }}>
                            <a
                                href="#"
                                data-toggle="collapse"
                                aria-expanded={openAvatar}
                                onClick={() => setOpenAvatar(!openAvatar)}
                                style={{ paddingBottom: 0 }}
                            >
                                <span style={{ color: 'white' }}>
                                    {props.LoggedInUser}
                                    <b className="caret" />
                                </span>
                            </a>
                        </div>
                        <div className='user' style={{ padding: 0, margin: 0 }}>
                            <div className='info' style={{ padding: 0, margin: 0 }}>
                                <a
                                    href="#"
                                    data-toggle="collapse"
                                    aria-expanded={openAvatar}
                                    style={{ padding: 0, margin: 0 }}
                                >
                                </a>
                                <Collapse isOpen={openAvatar} style={{ padding: 0, margin: 0 }}>
                                    <ul className="nav" style={{ padding: 0, margin: 0 }}>
                                        {createAccountRoutes(props.AccountRoutes)}
                                    </ul>
                                </Collapse>
                            </div>
                        </div>
                    </>
                }
                {props.AdvisoryRoutes == null &&
                    <Nav>
                        {createLinks(props.ProtectedRoutes)}
                        {createLinks(props.ConstantRoutes)}
                    </Nav>
                }
                {WSPScorecard.wspScorecardId && (
                    <>
                        <div className="user" />
                        {!isSidebarCollapsed && (
                            <>
                                <div className="user">
                                    <div className="info" style={{ paddingLeft: '15px' }}>
                                        <span style={{ color: "white" }}>{WSPScorecard.wspScorecardName}</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                {peoplAndTraining.OrganisationId > 0 && (
                    <>
                        <div className="user" />
                        {!isSidebarCollapsed && (
                            <>
                                <div className="user">
                                    <div className="info" style={{ paddingLeft: '15px' }}>
                                        <span style={{ color: "white" }}>{peoplAndTraining.OrganisationName}</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                {verificationCompany.vaClientId !== -1 && (
                    <>
                        <div className="user" />
                        {!isSidebarCollapsed && (
                            <>
                                <div className="user">
                                    <div className="info" style={{ paddingLeft: '15px' }}>
                                        <span style={{ color: "white" }}>{verificationCompany.company}</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                {BBBEEScorecard.scorecardName && (
                    <>
                        <div className="user" />
                        {!isSidebarCollapsed && (
                            <>
                                <div className="user">
                                    <div className="info" style={{ paddingLeft: '15px' }}>
                                        <span style={{ color: "white" }}>{BBBEEScorecard.scorecardName}</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                {props.AdvisoryRoutes != null &&
                    <Nav>
                        {createLinks(props.AdvisoryRoutes)}
                    </Nav>
                }
                {clientRegistration.clientRegistrationId && (
                    <>
                        <div className="user" />
                        {!isSidebarCollapsed && (
                            <>
                                <div className="user">
                                    <div className="info" style={{ paddingLeft: '15px' }}>
                                        <span style={{ color: "white" }}>{clientRegistration.clientRegistrationName}</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                {props.RegistrationRoutes?.length > 0 && (
                    <Nav>{createLinks(props.RegistrationRoutes)}</Nav>
                )}
                {scorecard.scorecardId && (
                    <>
                        <div className="user" />
                        {!isSidebarCollapsed && (
                            <>
                                <div className="user">
                                    <div className="info" style={{ paddingLeft: '15px' }} ref={eeScorecardSideBarRef}>
                                        <span style={{ color: "white" }}>EE Scorecard</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                {BBBEEScorecard.scorecardId && <div ref={beeScorecardSideBarRef} />}
                <Nav>{createLinks(props.DynamicRoutes)}</Nav>
            </div>
        </div>
    );
}
